/**
 * API base URL — runtime config.js, then env, then defaults.
 */
import { DEFAULT_API_URL, getApiUrl } from "./siteConfig";

const API_CONFIG = {
  BASE_URL: getApiUrl(),
  TIMEOUT: 30_000,
};

export { DEFAULT_API_URL };
export default API_CONFIG;
